import { render, staticRenderFns } from "./KeywordsList.vue?vue&type=template&id=48efd6a7&"
import script from "./KeywordsList.vue?vue&type=script&lang=js&"
export * from "./KeywordsList.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports